/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Ccsl_Export_Metadata_AuthorInputs */

const en_ccsl_export_metadata_author = /** @type {(inputs: Ccsl_Export_Metadata_AuthorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Author: ${i?.name}`)
};

const fr_ccsl_export_metadata_author = /** @type {(inputs: Ccsl_Export_Metadata_AuthorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Auteur : ${i?.name}`)
};

const de_ccsl_export_metadata_author = /** @type {(inputs: Ccsl_Export_Metadata_AuthorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Autor: ${i?.name}`)
};

const it_ccsl_export_metadata_author = /** @type {(inputs: Ccsl_Export_Metadata_AuthorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Autore: ${i?.name}`)
};

const ru_ccsl_export_metadata_author = /** @type {(inputs: Ccsl_Export_Metadata_AuthorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Автор: ${i?.name}`)
};

const es_ccsl_export_metadata_author = /** @type {(inputs: Ccsl_Export_Metadata_AuthorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Autor: ${i?.name}`)
};

const zh_cn2_ccsl_export_metadata_author = /** @type {(inputs: Ccsl_Export_Metadata_AuthorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`作者：${i?.name}`)
};

const ja_ccsl_export_metadata_author = /** @type {(inputs: Ccsl_Export_Metadata_AuthorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`著者: ${i?.name}`)
};

const hi_ccsl_export_metadata_author = /** @type {(inputs: Ccsl_Export_Metadata_AuthorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`लेखक: ${i?.name}`)
};

const pt_pt2_ccsl_export_metadata_author = /** @type {(inputs: Ccsl_Export_Metadata_AuthorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Autor: ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Author: {name}" |
*
* @param {Ccsl_Export_Metadata_AuthorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_metadata_author = /** @type {((inputs: Ccsl_Export_Metadata_AuthorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Metadata_AuthorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_metadata_author(inputs)
	if (locale === "de") return de_ccsl_export_metadata_author(inputs)
	if (locale === "it") return it_ccsl_export_metadata_author(inputs)
	if (locale === "ru") return ru_ccsl_export_metadata_author(inputs)
	if (locale === "es") return es_ccsl_export_metadata_author(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_metadata_author(inputs)
	if (locale === "ja") return ja_ccsl_export_metadata_author(inputs)
	if (locale === "hi") return hi_ccsl_export_metadata_author(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_metadata_author(inputs)
	return en_ccsl_export_metadata_author(inputs)
});